import React from 'react'
import MuiSnackbar from '@material-ui/core/Snackbar'
import IconButton from '@material-ui/core/IconButton'
import Slide from '@material-ui/core/Slide'
import { TransitionProps } from '@material-ui/core/transitions'
import { Check, CircleAlert, X } from 'lib/lucide'

import { useStyles } from './styles'

export type SnackbarVariant = 'success' | 'error'

interface SnackbarProps {
  message: React.ReactNode
  isOpen: boolean
  handleClose: () => void
  variant?: SnackbarVariant
}

interface ToastContentProps {
  variant: SnackbarVariant
  message: React.ReactNode
  onClose: () => void
}

const TransitionUp: React.FC<TransitionProps> = props => {
  return <Slide {...props} direction="up" />
}

const ToastContent = React.forwardRef<HTMLDivElement, ToastContentProps>(
  ({ variant, message, onClose }, ref) => {
    const classes = useStyles()
    const isError = variant === 'error'

    return (
      <div
        ref={ref}
        className={`${classes.toast} ${isError ? classes.toastError : classes.toastSuccess}`}
      >
        <span className={classes.icon}>
          {isError ? <CircleAlert size={20} /> : <Check size={20} />}
        </span>
        <div className={classes.body}>
          <span className={classes.title}>{isError ? 'Error' : 'Felicitaciones'}</span>
          <span className={classes.message}>{message}</span>
        </div>
        <IconButton className={classes.closeButton} onClick={onClose} aria-label="Cerrar">
          <X size={16} />
        </IconButton>
      </div>
    )
  },
)

const Snackbar: React.FC<SnackbarProps> = ({
  message,
  isOpen,
  handleClose,
  variant = 'success',
}) => {
  return (
    <MuiSnackbar
      open={isOpen}
      autoHideDuration={6000}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      TransitionComponent={TransitionUp}
    >
      <ToastContent variant={variant} message={message} onClose={handleClose} />
    </MuiSnackbar>
  )
}

export { Snackbar }
